window.addEventListener('load', () => {
  const locale = Shopify.locale;

  const currentCustomerType = window.ES_CUSTOMER_TYPE;

  const currentPricingInfo = window.ES_PRICING_INFO?.['standard'] || null;

  let selectedStart = null;
  let selectedEnd = null;
  let selectedWeekDays = 0;
  let picker = null;


  const defaultTranslations = {
    Jan: 'Jan',
    Feb: 'Feb',
    Mar: 'März',
    Apr: 'Apr',
    May: 'Mai',
    Jun: 'Juni',
    Jul: 'Juli',
    Aug: 'Aug',
    Sep: 'Sep',
    Oct: 'Oct',
    Nov: 'Nov',
    Dec: 'Dez',
  };

  let translations = defaultTranslations;

  if(locale === "en") {
    translations = {
        Jan: 'Jan',
        Feb: 'Feb',
        Mar: 'Mar',
        Apr: 'Apr',
        May: 'May',
        Jun: 'Jun',
        Jul: 'Jul',
        Aug: 'Aug',
        Sep: 'Sep',
        Oct: 'Oct',
        Nov: 'Nov',
        Dec: 'Dec',
    }
  }

  if(locale === "cs") {
    translations = {
        Jan: 'Led',
        Feb: 'Úno',
        Mar: 'Bře',
        Apr: 'Dub',
        May: 'Kvě',
        Jun: 'Čvn',
        Jul: 'Čvc',
        Aug: 'Srp',
        Sep: 'Zář',
        Oct: 'Říj',
        Nov: 'Lis',
        Dec: 'Pro',
    }
  }
  
  const tabletBreakpoint = 1040;
  const mobileBreakpoint = 758;
  const pickerMonthsDesktop = 2;
  const pickerMonthsTablet = 1;
  const pickerMonthsMobile = 3;

  const mietdauerInputName = 'properties[Mietdauer]';
  const priceInputName = 'properties[Rental Price]';
  const modalName = 'rental-period';
  
  let selectedSingleDate = null;
  let currentPickerMonths = getInitialPickerMonths();
  let targetInput = null;

  let weekendsEnabledSetting = false; 
  
  const overlay = document.body.querySelector('[data-modal-overlay="rental-period"]');
  const fromInput = overlay.querySelector(`input[name="from"]`);
  const toInput = overlay.querySelector(`input[name="to"]`);
  const cursor = document.querySelector('mouse-cursor');
  const weekendsSwitcher = document.getElementById('weekends_switcher_checkbox');
  
  const modal = overlay.querySelector('.modal');
  const modalBody = overlay.querySelector('.modal__body');
  const modalContentEl = overlay.querySelector('.modal__content');
  const modalFooterEl = overlay.querySelector('.modal__footer');
  const modalHeaderEl = overlay.querySelector('.modal__header');
  const modalSummaryEl = overlay.querySelector('.period-summary');

const original = {
  summaryParent: modalSummaryEl.parentNode,
  summaryNextSibling: modalSummaryEl.nextElementSibling,
  footerParent: modalFooterEl.parentNode,
  footerNextSibling: modalFooterEl.nextElementSibling
};

function rearrangeModal() {
  const isMobile = window.matchMedia("(max-width: 758px)").matches;

  if (isMobile) {
    if (modalSummaryEl.parentNode !== modalHeaderEl) {
      modalHeaderEl.appendChild(modalSummaryEl);
    }

    if (modalFooterEl.parentNode !== modalContentEl) {
      modalContentEl.appendChild(modalFooterEl);
    }
  } else {
    if (modalSummaryEl.parentNode !== original.summaryParent) {
      if (original.summaryNextSibling) {
        original.summaryParent.insertBefore(modalSummaryEl, original.summaryNextSibling);
      } else {
        original.summaryParent.appendChild(modalSummaryEl);
      }
    }

    if (modalFooterEl.parentNode !== original.footerParent) {
      if (original.footerNextSibling) {
        original.footerParent.insertBefore(modalFooterEl, original.footerNextSibling);
      } else {
        original.footerParent.appendChild(modalFooterEl);
      }
    }
  }
}

rearrangeModal();
window.addEventListener("resize", rearrangeModal);





  weekendsSwitcher.addEventListener('change', (e) => {
    weekendsEnabledSetting = e.currentTarget.checked;
    selectedWeekDays = countWeekdays(picker?.options?.startDate?.clone(), picker?.options?.endDate?.clone());
    updateDescription(picker?.options?.startDate, picker?.options?.endDate);
    picker?.render();
  })


  function periodToString (from, to) {
    return `${dateToString(from)} - ${dateToString(to)}`;
  }
  
  function dateToString (date) {
    return `${date.format('DD')}. ${translate(date.format('MMM'))} ${date.format('YYYY')}`;
  }
  
  function translate (value) {
    return translations[value] || value;
  }

  function periodToStringDE (from, to) {
    return `${dateToStringDE(from)} - ${dateToStringDE(to)}`;
  }
  
  function dateToStringDE (date) {
    return `${date.format('DD')}. ${translateDE(date.format('MMM'))} ${date.format('YYYY')}`;
  }
  
  function translateDE (value) {
    return defaultTranslations[value] || value;
  }
  
  function getInitialPickerMonths () {
    return isMobile() ? pickerMonthsMobile : isTablet() ? pickerMonthsTablet  : pickerMonthsDesktop;;
  }
  
  function isTablet () {
    return document.documentElement.clientWidth <= tabletBreakpoint;
  }

  function isMobile () {
    return document.documentElement.clientWidth <= mobileBreakpoint;
  }

  function getMietdauerInput () {
    return targetInput || document.querySelector(`input[readonly][name="${mietdauerInputName}"]`);
  }

  function getEstimatedPriceInput () {
    return document.querySelector(`input[readonly][name="${priceInputName}"]`);
  }
  
  function onDayRender (dayElement, date) {
    const innerElement = document.createElement('div');
    innerElement.className = 'day-item__value';
    innerElement.innerHTML = `<span>${dayElement.innerText}</span>`;
    const day = date.getDay();
    const isWeekendDay = !weekendsEnabledSetting ? day === 0 || day === 6 : false;

    
    if (selectedStart && selectedEnd && isDateInRange(date, selectedStart, selectedEnd)) {
        // if(!selectedWeekDays) return;

        
        const priceEl = document.createElement('span');
        priceEl.className = 'day-item__value--price';
        if (isWeekendDay) {
          priceEl.textContent = `-`;
          dayElement.classList.add('is-weekend-day')
        } else {
          currentPricingInfo ? (priceEl.textContent = `€${currentPricingInfo[selectedWeekDays] ?? currentPricingInfo[31]}`) : (priceEl.textContent = '');
        }
        innerElement.appendChild(priceEl);
    } 
    dayElement.innerHTML = innerElement.outerHTML;

  }

  function onSelected (from, to) {
    selectedStart = from;
    selectedEnd = to;
    selectedWeekDays = countWeekdays(selectedStart?.clone(), selectedEnd?.clone());

    updateDateInput('from', from);
    updateDateInput('to', to);
    
    updateProductForm(from, to);
    updateDescription(from, to);
    updateFooter(from, to);

    updateSelectedSingleDate(from, to);
    picker.render();
  };

  function clearSelection () {
    selectedStart = 0;
    selectedEnd = 0;
    selectedWeekDays = 0;

    updateDateInput('from');
    updateDateInput('to');

    picker.clearSelection();
    picker.render();
    updateProductForm();
    updateDescription();
    updateFooter();

    updateSelectedSingleDate();
  }

  function onPriceInputChange() {

  }

  function onDateInputChange (input) {
    if (!isDateValid(input.value)) {
      input.parentElement.classList.add('invalid');
      picker.clearSelection();
      return;
    }

    fixDatesOrder();
    setDateRangeFromInputs();
  }

  function setDateRangeFromInputs () {
    picker.setDateRange(fromInput.value || toInput.value || null, toInput.value || fromInput.value || null);

    const fromDate = fromInput.value ? picker.getStartDate() : null;
    const toDate = toInput.value ? picker.getEndDate() : null;
    updateProductForm(fromDate, toDate);
    updateDescription(fromDate, toDate);
    updateFooter(fromDate, toDate);
    updateSelectedSingleDate(fromDate, toDate);
  }

  function updateSelectedSingleDate (from = null, to = null) {
    selectedSingleDate = from && !to ? from.getTime() : null;
  }

  function updateDateInput (name, date) {
    const input = overlay.querySelector(`input[name="${name}"]`);
    input.value = date ? date.format('DD.MM.YYYY') : '';
  }

  function updateDescription (from, to) {
    const locale = Shopify.locale;
    const description = overlay.querySelector('.period-summary__description');
    const descriptionContent = description.querySelector('div');
    const estimatedValue = overlay.querySelectorAll('.period-summary__estimated-price'); 
    const estimatedPriceContainer = overlay.querySelectorAll('.period-summary__estimated-totals')
    if (to) {
      description.classList.add('period-summary__description_with-clear-button');
      let text = 'Werktage';
      if(locale == 'en') {
        text = 'Banking days'
      }
      if(locale == 'cs') {
        text = 'Pracovní dny'
      }
      descriptionContent.innerHTML = `${selectedWeekDays} ${text}`;
      estimatedValue.forEach(v => v.innerHTML =  `${(currentPricingInfo?.[selectedWeekDays] ?? currentPricingInfo?.[31] ?? 0) * selectedWeekDays} €`)
      estimatedPriceContainer.forEach(c => c.hidden = !currentPricingInfo)
      const input = getEstimatedPriceInput()
      input && (input.value = `${(currentPricingInfo?.[selectedWeekDays] ?? currentPricingInfo?.[31] ?? 0) * selectedWeekDays} €`)
      
      
      // 
    } else if (from) {
      description.classList.remove('period-summary__description_with-clear-button');
      let text = 'Bis wann möchtest du das Gerät mieten?';
      if(locale == 'en') {
        text = 'Until when do you want to rent the device?'
      }
      if(locale == 'cs') {
        text = 'Do kdy si chcete přístroj pronajmout?'
      }
      descriptionContent.innerHTML = text;
      estimatedPriceContainer.forEach(c => c.hidden = true)
    } else {
      description.classList.remove('period-summary__description_with-clear-button');
      let text = 'Ab wann möchtest du das Gerät mieten?';
      if(locale == 'en') {
        text = 'When do you want to rent the device from?'
      }
      if(locale == 'cs') {
        text = 'Kdy si chcete přístroj pronajmout?'
      }
      descriptionContent.innerHTML = text;
      estimatedPriceContainer.forEach(c => c.hidden = true)
    }
  }

  function updateFooter (from, to) {
    const locale = Shopify.locale;
    const footer = overlay.querySelector('.modal__footer');
    const footerInfo = footer.querySelector('.modal__footer-info');
    const footerButton = overlay.querySelectorAll('[data-hide-modal]');
    if (from && to) {
      const days = countWeekdays(from.clone?.(), to.clone?.());
      let text = `<span>Mietdauer:</span> <span class="modal__footer-info_bold">${days} Tag${days > 1 ? 'e' : ''}</span>`;
      if(locale == 'en') {
        text = `<span>Rental period:</span><span class="modal__footer-info_bold">${days} Day${days > 1 ? 's' : ''}</span>`
      }
      if(locale == 'cs') {
        text = `<span>Doba pronájmu:</span> <span class="modal__footer-info_bold">${days} ${days > 1 && days < 5 ? 'Dny' : days > 1 ? 'Dni' : 'Den'}</span>`
      }
      footerInfo.innerHTML = text;
      // footerInfo.classList.add('modal__footer-info_bold');
      if(selectedWeekDays > 0) {
        footerButton.forEach(btn => btn.removeAttribute('disabled'));
      }
    } else {
      let text = 'Mietdauer auswählen um Gerät anzufragen'
      if(locale == 'en') {
        text = `Select the rental period to request a device`
      }
      if(locale == 'cs') {
        text = `Vyberte si dobu pronájmu pro dotaz na zařízení`
      }
      footerInfo.innerText = text;
      // footerInfo.classList.remove('modal__footer-info_bold');
      footerButton.forEach(btn => btn.setAttribute('disabled', true));
    }
  }

  function updateProductForm (from, to) {
    const input = getMietdauerInput();
    if (!input) {
      return;
    }

    input.value = from && to ? periodToStringDE(from, to) : '';

    // const atcs = document.querySelectorAll('.product-form__submit, swipe-btn');
    // atcs.forEach(atc => {
    //   if (atc) {
    //     if (from && to) {
    //       atc.removeAttribute('disabled');
    //     } else {
    //       atc.setAttribute('disabled', true);
    //     }
    //   }
    // })
  }

  function fixDatesOrder () {
    if (!fromInput.value || !toInput.value || fromInput.value < toInput.value) {
      return;
    }

    const tmp = fromInput.value;
    fromInput.value = toInput.value;
    toInput.value = tmp;
  }

  function isDateValid (value) {
    if (value === '') {
      return true;
    }
    
    const dateExpression = /\d{1,2}\.\d{1,2}\.\d{4}/ui;
    if (!dateExpression.test(value)) {
      return false;
    }
    
    const dateParts = value.split('.');
    if (dateParts.length !== 3) {
      return false;
    }

    const now = new Date();
    const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    
    return date >= tomorrow;
  }

  function addPickerMonths () {
    currentPickerMonths += pickerMonthsMobile;
    picker.setOptions({numberOfMonths: currentPickerMonths});
    selectLastSingleDate();
  }

  function selectLastSingleDate () {
    if (!selectedSingleDate) {
      return;
    }

    const day = overlay.querySelector(`.day-item[data-time="${selectedSingleDate}"]`);
    if (day) {
      day.dispatchEvent(new Event('click'));
    }
  }

  function resetMonths () {
    currentPickerMonths = getInitialPickerMonths();
    picker.setOptions({numberOfMonths: currentPickerMonths});
  }

  function countWeekdays(start, end) {
    if(!start || !end) return 0;
    let count = 0;
    const current = new Date(start.dateInstance);

    while (current <= end.dateInstance) {
      const day = current.getDay();
      if (weekendsEnabledSetting || (day !== 0 && day !== 6)) {
        count++;
      }
      current.setDate(current.getDate() + 1);
    }

    return count;
  }

  function isDateInRange(date, start, end) {
    if (!date || !start || !end) return false;

    const d = new Date(date.dateInstance);
    const s = new Date(start.dateInstance);
    const e = new Date(end.dateInstance);

    d.setHours(0, 0, 0, 0);
    s.setHours(0, 0, 0, 0);
    e.setHours(0, 0, 0, 0);

    return d >= s && d <= e;
  }

  // Litepicker setup
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);


  
  picker = new Litepicker({
    element: document.querySelector('[data-rental-period-picker]'),
    format: 'DD.MM.YYYY',
    minDate: yesterday,
    showTooltip: false,
    switchingMonths: 1,
    singleMode: false,
    numberOfMonths: currentPickerMonths,
    inlineMode: true,
    lang: locale,
    setup: picker => {
      picker.on('render:day', onDayRender);
      picker.on('preselect', onSelected);
    },
  });

  

  // Event listeners
  overlay.addEventListener("change", function (e) {
    if (e.target.classList.contains("period-summary__date-value")) {
      onDateInputChange(e.target);
    }
  });
  
  overlay.addEventListener("input", function (e) {
    if (e.target.classList.contains("period-summary__date-value")) {
      const wrapper = e.target.parentElement;
      wrapper.classList.remove('invalid');
    }
  });
  
  overlay.addEventListener('click', function (e) {
    if (e.target.dataset.action === 'clear-selection') {
      e.preventDefault();
      clearSelection();
      return;
    }

    if (e.target.className === 'day-item__value') {
      e.target.parentElement.dispatchEvent(new Event('click'));
      return;
    }

    if (e.target.dataset.action === 'show-next-months') {
      addPickerMonths();
    }
  });

  overlay.addEventListener('mouseenter', function () {
    cursor.classList.add('active');
  });

  overlay.addEventListener('mouseleave', function () {
    cursor.classList.remove('active');
  });

  modal.addEventListener('mouseenter', function () {
    cursor.classList.remove('active');
  });

  modal.addEventListener('mouseleave', function () {
    cursor.classList.add('active');
  });

  document.body.addEventListener('click', function (e) {
    const submit = e.target.closest('.quick-add button[type="submit"]');
    if (!submit) {
      return;
    }

    const form = submit.form;

    targetInput = form[mietdauerInputName];
    targetInput = form[priceInputName];
    if (!targetInput) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    window.showModal(modalName);
    setDateRangeFromInputs();
  });

  window.addEventListener('modal:hide', function (e) {
    window.rentalSpecialConditions = false;
    if (e.detail?.name !== modalName || !targetInput) {
      return;
    }

    const input = targetInput;
    targetInput = null;
    
    if (!input.value) {
      return;
    }

    input.form.dispatchEvent(new Event('submit', {view: window, bubbles: true,cancelable: true}));
  });

  const stickyAtc = document.querySelector('.sticky-buy-button__variant button[type="submit"]');
  if (stickyAtc) {
    stickyAtc.addEventListener('click', e => {
      const input = getMietdauerInput();
      if (!input || input.value) {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      window.showModal(modalName);

      return false;
    });
  }
  
  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(resetMonths, 100);
  });


  const footer = overlay.querySelector('.modal__footer');
  const buttons = overlay.querySelectorAll('.period-summary [data-hide-modal], .modal__footer button') 

  if(buttons.length){
      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          if(!window.currentRentalATC) window.currentRentalATC = document.querySelector('[data-atc-rental]');
          if(!window.currentRentalATC) window.currentRentalATC = document.querySelector('form.product-form [type="submit"]');
          if(window.currentRentalATC) {
            const form = document.getElementById(window.currentRentalATC.getAttribute('form'));
            // add line item prop window.rentalSpecialConditions
              
            // end and line item prop
            if(form) form.dispatchEvent(new Event('submit', {view: window, bubbles: true,cancelable: true}));
            window.rentalSpecialConditions = false;

          }
        })
      })
  }

  if (new URLSearchParams(window.location.search).get('openCalendar') === 'true') {
    const rentalPeriodModal = document.querySelector('[data-show-modal="rental-period"]');
    !!rentalPeriodModal && setTimeout(() => {
      window.showModal(modalName);
    }, 1000)
  }
});